import React from 'react'
import DocComponent from '../../components/doc-component/DocComponent'

function Doc() {
  return (
    <div><DocComponent/></div>
  )
}

export default Doc